// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Xkno","name":"Header_name__2mD1g","birthday":"Header_birthday__1VmGa","skeleton":"Header_skeleton__2s9a5"};